import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* THE HEADERS OF EVERY REQUEST OF THE SECTION */
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* List Messages — type is the tab: "all" или "censored" */
export const list = ({ page = 1, type = "all", search = "", operators = "", tables = "", start = "", end = "", testers = true }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ page: page || 1, timezone: utils.getTimezone() })

    if (type && type !== "all") params.set("type", type)
    if (search) params.set("search", search)
    if (operators) params.set("operators", operators)
    if (tables) params.set("tables", tables)
    if (start) params.set("start", start)
    if (end) params.set("end", end)
    if (!testers) params.set("testers", "0")

    /* Send Request */
    const uri = `${env.startpoint}message/list?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section (операторы и игры — строго в рамках доступа токена) */
export const filters = () => {

    const uri = `${env.startpoint}message/filters`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* List The Dictionary Of The Censor — читать может любая роль */
export const censorList = ({ search = "" } = {}) => {

    /* Prepare Params */
    const params = new URLSearchParams()

    if (search) params.set("search", search)

    /* Send Request */
    const uri = `${env.startpoint}message/censor/list?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Add A Word To The Dictionary */
export const censorCreate = ({ word, type = "root", comment = "" }) => {

    const uri = `${env.startpoint}message/censor/create`

    return axios.post(uri, { word, type, comment }, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Change A Word Of The Dictionary */
export const censorUpdate = (data) => {

    const uri = `${env.startpoint}message/censor/update`

    return axios.post(uri, data, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Remove A Word From The Dictionary */
export const censorDelete = ({ id }) => {

    const uri = `${env.startpoint}message/censor/delete`

    return axios.post(uri, { id }, getHeaders()).then((response) => response).catch((data) => data.response)
}
